import axios from '@/api/config';

const examType = {
  getExamTypeById(data) {
    return axios.get(`${process.env.BASE_URL}/examType/getExamType/` + data, {});
  },
  getExamType(data) {
    return axios.get(`${process.env.BASE_URL}/examType/getExamType`, {params: data});
   },
  getExamTypeList(data) {
    return axios.get(`${process.env.BASE_URL}/examType/getExamTypeList`, {params: data});
  },
  getExamTypeTree(data) {
    return axios.get(`${process.env.BASE_URL}/examType/getExamTypeTree`, {params: data});
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/examType/pageList`, data);
  },
  addExamType(data) {
    return axios.post(`${process.env.BASE_URL}/examType/addExamType`, data);
  },
  updateExamType(data) {
    return axios.put(`${process.env.BASE_URL}/examType/updateExamType`, data);
  },
  deleteExamType(data) {
    return axios.delete(`${process.env.BASE_URL}/examType/deleteExamType`,  {data: data});
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/examType/exportExcel`, {params: data});
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/examType/importData`, data);
  }
}

export default examType;



// WEBPACK FOOTER //
// ./src/api/examType.js